import { Item } from "@thenounproject/lingo-core";

import { Inspectable } from "@constants/Inspector";

export function hasContextMenu(inspectables: Inspectable[], item?: Item): boolean {
  if (inspectables.length > 1 && item?.data?.viewId) return false;
  return true;
}
